export type VisualizationDataTableFilterType = VisualizationDataTableFilterControlType | VisualizationDataTableFilterLayoutType;

export enum VisualizationDataTableFilterControlType {
  Dropdown = 1,
  SearchBar = 2,
  DateRange = 3,
  Toggle = 4,
}

export enum VisualizationDataTableFilterLayoutType {
  Grid = 101,
  Stack = 102,
}